module.exports = __webpack_public_path__ + "img/selly.bc349f99.png";